

















































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { subnetMap, VMMap, VMDocumentationMap, VMFullNameMap } from '@/helper'
import Blockchain from '@/js/Blockchain'
import Indexed from '@/components/Blockchain/Indexed.vue'
import { getTastChainType } from '@/known_blockchains'
import { ATH, AST, ACT } from '@/known_blockchains'
import { DEFAULT_NETWORK_NAME } from '@/store/modules/network/network'

@Component({
    components: {
        Indexed,
    },
})
export default class BlockchainDataTable extends Vue {
    @Prop() blockchains!: Blockchain[]
    @Prop() links?: boolean
    @Prop() subnets?: boolean
    @Prop() title?: string
    get headers(): any[] {
        const headers = [
            { text: 'Name', value: 'name', width: 200, fixed: true },
            { text: 'VM', value: 'vmID', width: 125 },
            { text: 'Subnet', value: 'subnetID', width: 300 },
            { text: 'Index', value: 'indexed', width: 125, sortable: false },
        ]
        return this.subnets ? headers : headers.slice(0, 5)
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }

    chainDarkColor(id: string) {
        switch (id) {
            case ATH.id:
                return getTastChainType(id)!.darkColor
            case AST.id:
                return getTastChainType(id)!.darkColor
            case ACT.id:
                return getTastChainType(id)!.darkColor
            default:
                return '#FFF'
        }
    }

    chainCode(id: string) {
        switch (id) {
            case ATH.id:
                return getTastChainType(id)!.code
            case AST.id:
                return getTastChainType(id)!.code
            case ACT.id:
                return getTastChainType(id)!.code
            default:
                return ''
        }
    }

    subnet(val: string) {
        return subnetMap(val)
    }

    vm(val: string) {
        return VMMap(val)
    }

    vmDocumentation(val: string) {
        return VMDocumentationMap(val)
    }

    vmFullName(val: string) {
        return VMFullNameMap(val)
    }

    generateURL(path: string, item: any) {
        const baseUrl = path // Base URL without query parameters
        const queryParams: { [network: string]: string } = {
            network: DEFAULT_NETWORK_NAME,
            subnet:
                item.subnetID !== '11111111111111111111111111111111LpoYY'
                    ? item.name.toLowerCase()
                    : '',
        } // Query parameters and their values

        // Generate the URL by appending the query parameters
        const url = new URL(baseUrl, window.location.origin)
        Object.keys(queryParams).forEach((key) => {
            url.searchParams.append(key, queryParams[key])
        })

        return url.toString()
    }
}
